import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../styles/reviewrequest.css";
import { useAppDispatch, useAppSelector } from "../hooks/useSelector";
import RejectModal from "../components/reejectmodal";

import DeliveryCodeModal from "../components/delivercode";
import { get, post, put } from "../config/api";
import { RequestState } from "../constants/textconstants";
import {
  updateCurrentRequest,
  updateCurrentRequestActive,
} from "../store/slices/pendingRequests";
import { BackArrow, Download, Info } from "../constants";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { showError, showToast } from "../store/slices/formconfig";
import CancelModal from "../components/cancelmodal";
import DistributorMappingModal from "../components/distributorMappingModal";
import { formatDateToDDMMYYYY } from "../utils/dateUtils";
import { downloadFile, getFileNameFromUrl } from "../helper-functions";
import { TESTING_DATA } from "../constants/isTesting";
import ApproveModal from "../components/approvemodal";
import { Loader } from "../components/loader";
import { usePermissions } from "../hooks/usePermissions";
import { FEATURES } from "../config/permissions";
import { ROLES } from "../constants/textconstants";

const ReviewRequestPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isReadOnly = location.state?.readOnly === true;
  const dispatch = useAppDispatch();
  const { can, isViewer } = usePermissions();

  const requests = useAppSelector((state: any) => state.requests.data);
  const issuedRequests = useAppSelector(
    (state: any) => state.requests.issuedCertificates
  );
  const userData = useAppSelector((state: any) => state.formConfig.user);
  const isMhLicenseManager =
    userData?.role === ROLES.LICENSE_MANAGER && !!userData?.show_govt_approval_tab;
  const canApproveOrReject = can(FEATURES.ACTION_APPROVE_REQUEST) || isMhLicenseManager;

  const [requestData, setRequestData] = useState<any>({});
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);

  const [certificateData, setCertificateData] = useState<any | null>(null);
  const [bookletData, setBookletData] = useState<any>({});

  const [showDeliveryCodeModal, setShowDeliveryCodeModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDistributorMappingModal, setShowDistributorMappingModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewType, setPreviewType] = useState<"image" | "pdf">("image");
  const [previewZoom, setPreviewZoom] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);

  // const fetchCertificateData = async (id: any) => {
  //   try {
  //     const response = await get(API_ENDPOINTS.CERTIFICATE_BY_ID(id!));
  //     if (response) {
  //       console.log(response, "----000--00");
  //       setCertificateData(response.certificate);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch certificate details:", error);
  //     setCertificateData(null);
  //   }
  // };

  const fetchRequestData = async () => {
    setIsLoadingRequest(true);
    try {
      let response: any = {};
      if (userData.is_viewed_guided_tour) {
        response = await get(API_ENDPOINTS.CERTIFICATE_REQUEST_BY_ID(id!));
      } else {
        if (id == '1') {
          response = TESTING_DATA.REVIEW_REQUEST;
        } else if (id == '2') {
          response = TESTING_DATA.REVIEW_REQUEST_DELIVERY;
        }
        else {
          response = TESTING_DATA.REVIEW_REQUEST_COMPLETE;
        }


      }


      if (response && response.status.toLowerCase() !== "pending approval") {
        setCertificateData({
          ...response.certificate,
          delivery_date: response.delivery_date,
        });
        // fetchCertificateData(id);
      }
      setRequestData({ ...requestData, ...response });
      return response;
    } catch (error) {
      dispatch(showError({ message: `Failed to fetch certificate details, due to some technical issue, please try again`, visible: true }))

      console.error("Failed to fetch certificate details:", error);
      setCertificateData(null);
    } finally {
      setIsLoadingRequest(false);
    }
  };

  useEffect(() => {
    fetchRequestData();
  }, [id, requests]);

  if (!requestData || Object.keys(requestData).length === 0) {
    return <div>Loading...</div>;
  }

  const isApproveRejectState =
    requestData?.status?.toLowerCase() === RequestState.PENDING.toLowerCase() ||
    (isMhLicenseManager &&
      requestData?.status?.toLowerCase() ===
      RequestState.CERTIFICATE_ISSUANCE.toLowerCase());
      
  const showMhCertificateDetailsView =
    !!requestData?.govt_application_number &&
    String(requestData.govt_application_number).trim() !== "";

  const handleRejectClick = () => {
    setShowRejectModal(true);
  };

  const handleDeliveryClick = () => setShowApproveModal(true);

  const handleApproveClick = () => {
    if (isMhLicenseManager) {
      setShowApproveModal(true);
      return;
    }
    setShowDistributorMappingModal(true);
  };

  const handleCancelSubmit = async (internalRemarks: string) => {
    let dataToSubmit = {
      remarks: "Certificate Cancelled",
      reason: internalRemarks,
    };
    try {
      const response = await put(
        API_ENDPOINTS.CERTIFICATE_REQUESTS_CANCEL(id || ""),
        dataToSubmit
      );
      if (response) {
        dispatch(showToast({ message: "Certificate request cancelled!", type: "success" }));
        setShowCancelModal(false);
        navigate(-1);
      } else {
        dispatch(showToast({ message: "Failed to cancel certificate request. Please try again.", type: "error" }));
      }
    } catch (error) {
      dispatch(showToast({ message: "An error occurred. Failed to cancel certificate request.", type: "error" }));
      console.error("API call failed:", error);
    }
  };


  const handleRejectSubmit = async (
    reason: string,
    internalRemarks: string
  ) => {
 

    let dataToSubmit = {};

    if (isMhLicenseManager) {
      dataToSubmit = {
        remarks: internalRemarks,
        reason: reason,
      }
    }
    else {
      dataToSubmit = {
        remarks: internalRemarks,
        reason: reason,

      }
    }

    try {
      const rejectEndpoint = isMhLicenseManager
        ? API_ENDPOINTS.CERTIFICATE_ISSUE_REJECT
        : API_ENDPOINTS.CERTIFICATE_REQUESTS_REJECT(id || "");
      const rejectUrl = isMhLicenseManager
        ? `${rejectEndpoint}?userId=${userData.userId}&countryCode=IN&requestId=${requestData?.request_id}`
        : `${rejectEndpoint}?userId=${userData.userId}&countryCode=IN`;
      const response = await put(
        rejectUrl,
        dataToSubmit
      );
      if (response) {
        dispatch(showToast({ message: "Certificate request rejected!", type: "success" }));
        setShowRejectModal(false);
        navigate(-1);
      } else {
        dispatch(showToast({ message: "Failed to reject certificate request. Please try again.", type: "error" }));
      }
    } catch (error) {
      dispatch(showToast({ message: "An error occurred. Failed to reject certificate request.", type: "error" }));
      console.error("API call failed:", error);
    }
    setShowRejectModal(false);
  };


  const handleDeliveryinfoClick = async (data: any): Promise<boolean> => {
    let parsedData = Number(id);

    if (isMhLicenseManager) {
      setIsSubmitting(true);
      try {
        const response = await post(
          `${API_ENDPOINTS.CERTIFICATES}`,
          {
            certificate_number: data.certificateNo,
            expiry_date: data.expiryDate,
            request_id: parsedData,
            partner: {
              partner_id: requestData.partner_id,
            },
            issued_by: userData.userId,
          }
        );
        if (response) {
          dispatch(updateCurrentRequest(parsedData));
          await fetchRequestData();
          return true;
        } else {
          dispatch(
            showError({
              message: "Failed to approve certificate request. Please try again.",
              visible: true,
            })
          );
          return false;
        }
      } catch (error: any) {
        dispatch(
          showError({
            message: `Failed to approve certificate request. Please try again. ${error.message ? error.message : ""
              }`,
            visible: true,
          })
        );
        return false;
      } finally {
        setIsSubmitting(false);
      }
    }

    let dataToSubmit = {
      request_id: parsedData,
      partner: {
        partner_id: requestData.partner_id,
      },
      certificate_number: data.certificateNo,
      issued_by: userData.userId,

      expiry_date: data.expiryDate,
      certificate_copy_first_page_url: data.firstPageUrl,
      certificate_copy_last_page_url: data.lastPageUrl,
    };
    console.log("Submitting delivery info:", dataToSubmit);
    let stringifieddata = JSON.stringify(dataToSubmit);
    try {
      const response = await post(API_ENDPOINTS.CERTIFICATES, stringifieddata);
      if (response) {
        dispatch(updateCurrentRequest(data.request_id));
        await fetchRequestData();
        return true;
      } else {
        dispatch(
          showError({
            message: "Failed to approve certificate request. Please try again.",
            visible: true,
          })
        );
        return false;
      }
    } catch (error: any) {
      dispatch(
        showError({
          message: `Failed to approve certificate request. Please try again. ${error.message ? error.message : ""
            }`,
          visible: true,
        })
      );
      return false;
    }
  };


  const handleDistributorMappingSubmit = async (selectedDistributors: any[]) => {
    const distributorIds = selectedDistributors.map((d: any) => d.id || d.partner_id);
    setIsSubmitting(true);
    try {
      const response = await put(
        `${API_ENDPOINTS.CERTIFICATE_REQUESTS_APPROVE(id || "")}?userId=${userData.userId}`,
        { distributor_ids: distributorIds }
      );
      if (response) {
        dispatch(showToast({ message: "Certificate request approved successfully!", type: "success" }));
        setShowDistributorMappingModal(false);
        navigate(-1);
      } else {
        dispatch(
          showError({
            message: "Failed to approve certificate request. Please try again.",
            visible: true,
          })
        );
      }
    } catch (error: any) {
      dispatch(
        showError({
          message: `Failed to approve certificate request. ${error.message || ""}`,
          visible: true,
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeliveryCodeClick = () => setShowDeliveryCodeModal(true);

  const handleDeliveryCodeSubmit = async (deliveryCode: string) => {
    if (deliveryCode === requestData.delivery_code) {
      try {
        const response = await post(
          `${API_ENDPOINTS.CERTIFICATE_REQUESTS_DELIVER(
            requestData.request_id
          )}?delivery_code=${deliveryCode}`,
          {}
        );
        if (response) {
          dispatch(updateCurrentRequestActive(requestData.request_id));
          navigate(-1);
        }
        console.log("Status updated to Active successfully.");
      } catch (error: any) {
        dispatch(
          showError({
            message: error.message,
            visible: true,
          })
        );
        console.error("Failed to update status:", error);
      }
    } else {
      dispatch(showToast({ message: "Delivery code mismatch!", type: "error" }));
    }

    setShowDeliveryCodeModal(false);
  };

  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case "pending approval":
        return "status-pending";
      case "pending delivery":
        return "status-pending-delivery";
      case "active":
        return "status-active";
      case "certificate issuance":
        return "status-certificate-issuance";
      case "rejected":
      case "expired":
        return "status-pill-rejected";
      case "cancelled":
        return "status-cancelled";
      default:
        return "";
    }
  };

  const getFileType = (url: string): "image" | "pdf" => {
    const lowerUrl = (url || "").toLowerCase();
    const urlWithoutQuery = lowerUrl.split("?")[0];
    const isPdf =
      urlWithoutQuery.endsWith(".pdf") ||
      lowerUrl.startsWith("data:application/pdf");
    return isPdf ? "pdf" : "image";
  };

  const handlePreviewOpen = (url: string) => {
    if (!url) {
      return;
    }
    setPreviewUrl(url);
    setPreviewType(getFileType(url));
    setPreviewZoom(1);
    setShowPreviewModal(true);
  };

  const handlePreviewClose = () => {
    setShowPreviewModal(false);
    setPreviewZoom(1);
  };

  const handleZoomIn = () => setPreviewZoom((prev) => Math.min(prev + 0.25, 3));
  const handleZoomOut = () => setPreviewZoom((prev) => Math.max(prev - 0.25, 0.5));

  return (
    <div
      style={{
        background: "rgb(236, 239, 241)",
        padding: 30,
        paddingTop: 100,
        paddingBottom: 80,
      }}
    >
      {(isSubmitting || isLoadingRequest) && <Loader />}
      <div style={{ paddingBottom: 0 }}>
        <button className="back-button" onClick={() => navigate(-1)}>
          <img src={BackArrow} alt="Back" height={20} style={{ marginRight: 10 }} />{" "}
          {certificateData
            ? "Certificate Details"
            : "Review Certificate Request"}
        </button>
      </div>
      <div className="review-request-container">
        <div className="review-request-header">
          <div className="header-item">
            <label>Firm Name</label>
            <span style={{ maxWidth: 200, wordBreak: 'break-word' }}>{requestData.firm_name}</span>
          </div>
          <div className="header-item">
            <label>BRP ID</label>
            <span>{requestData.partner_id}</span>
          </div>
          <div className="header-item">
            <label>Submitted On</label>
            <span>{formatDateToDDMMYYYY(requestData.created_at)}</span>
          </div>
          <div className={`status-pill ${getStatusClass(requestData.status)}`}>
            {requestData.status.toLowerCase() === "approved"
              ? "Pending Delivery"
              : requestData.status}
          </div>
        </div>

        <div className="submitted-details-section">
          <span className="heading">Submitted Details</span>
          <div className="details-grid">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div className="detail-item">
                <label>Unique Request ID</label>
                <span>
                  {requestData.govt_application_number
                    ? requestData.govt_application_number
                    : requestData.request_id}
                </span>
                {requestData.govt_application_number && (
                  <p>(Request ID as per Mahaparwana govt. site)</p>
                )}
              </div>
              <div className="detail-item">
                <label>Firm Name (as per License)</label>
                <span>{requestData.firm_name}</span>
              </div>
              <div className="detail-item">
                <label>GST Number</label>
                <span>{requestData.gst_number}</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div className="detail-item">
                <label>License Number</label>
                <span>{requestData.license_number}</span>
              </div>
              <div className="detail-item">
                <label>License Issue Date</label>
                <span>
                  {formatDateToDDMMYYYY(requestData.license_issued_date)}
                </span>
              </div>
              <div className="detail-item">
                <label>License Expiry Date</label>
                <span>
                  {formatDateToDDMMYYYY(requestData.license_expiry_date)}
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div className="detail-item">
                <label>License copy</label>
                {requestData.license_documents &&
                  requestData.license_documents.map((item: any, index: number) => {
                    return (
                      <span key={`${item.document_url}-${index}`} className="file-actions-row">
                        <a
                          href={item.document_url}
                          className="link-button"
                          target="_blank"
                          rel="noopener noreferrer"
                        // onClick={() =>
                        //   downloadFile(item.document_url, getFileNameFromUrl(item.document_url))
                        // }
                        >
                          Download
                          <img
                            src={Download}
                            alt="Download"
                            height={20}
                            style={{ marginLeft: 5, marginTop: 5 }}
                          />
                        </a>
                        <button
                          type="button"
                          className="preview-icon-button"
                          onClick={() => handlePreviewOpen(item.document_url)}
                          title="Preview file"
                        >
                          <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 5C6.5 5 2 9.5 1 12c1 2.5 5.5 7 11 7s10-4.5 11-7c-1-2.5-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2.2A1.8 1.8 0 1 0 12 10a1.8 1.8 0 0 0 0 3.8Z" />
                          </svg>
                        </button>
                      </span>
                    );
                  })}
              </div>
              <div className="detail-item">
                <label>Products for Certificate</label>
                <span>{requestData.products.join(", ")}</span>
              </div>
              <div className="detail-item">
                <label>Shop Address</label>
                <span>
                  {requestData.shop_address + ", " + requestData.shop_district + ", " + requestData.shop_pincode}
                </span>
              </div>
            </div>

            <div className="detail-item full-row">
              <label>Godown Address</label>
              <span>{requestData.godown_address + ", " + requestData.godown_district + ", " + requestData.godown_pincode}</span>
            </div>
          </div>
        </div>

        {certificateData && certificateData.certificate_number && requestData.status.toLowerCase() !== "rejected" && (
          <div className="submitted-details-section">
            <span className="heading">Certificate Details</span>
            <div className="details-grid">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 24,
                }}
              >
                {!showMhCertificateDetailsView && <div className="detail-item">
                  <label>Certificate copy</label>
                  <span className="file-actions-row">
                    <a
                      href={certificateData.certificate_copy_first_page_url}
                      className="link-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    // onClick={() =>
                    //   downloadFile(certificateData.certificate_copy_first_page_url, getFileNameFromUrl(certificateData.certificate_copy_first_page_url))
                    // }
                    >
                      Download First Page
                      <img
                        src={Download}
                        alt="Download"
                        height={20}
                        style={{ marginLeft: 5, marginTop: 5 }}
                      />
                    </a>
                    <button
                      type="button"
                      className="preview-icon-button"
                      onClick={() => handlePreviewOpen(certificateData.certificate_copy_first_page_url)}
                      title="Preview file"
                    >
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 5C6.5 5 2 9.5 1 12c1 2.5 5.5 7 11 7s10-4.5 11-7c-1-2.5-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2.2A1.8 1.8 0 1 0 12 10a1.8 1.8 0 0 0 0 3.8Z" />
                      </svg>
                    </button>
                  </span>
                  <span className="file-actions-row">
                    <a
                      href={certificateData.certificate_copy_last_page_url}
                      className="link-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    // onClick={() =>
                    //   downloadFile(certificateData.certificate_copy_last_page_url, getFileNameFromUrl(certificateData.certificate_copy_last_page_url))
                    // }
                    >
                      Download Last Page
                      <img
                        src={Download}
                        alt="Download"
                        height={20}
                        style={{ marginLeft: 5, marginTop: 5 }}
                      />
                    </a>
                    <button
                      type="button"
                      className="preview-icon-button"
                      onClick={() => handlePreviewOpen(certificateData.certificate_copy_last_page_url)}
                      title="Preview file"
                    >
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 5C6.5 5 2 9.5 1 12c1 2.5 5.5 7 11 7s10-4.5 11-7c-1-2.5-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2.2A1.8 1.8 0 1 0 12 10a1.8 1.8 0 0 0 0 3.8Z" />
                      </svg>
                    </button>
                  </span>
                </div>}
                {!showMhCertificateDetailsView && <div className="detail-item">
                  <span>
                    <label>Issue Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date of Certificate Approval and Issuance`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {formatDateToDDMMYYYY(certificateData.issued_date)}
                  </span>
                </div>}
                {!showMhCertificateDetailsView && <div className="detail-item">
                  <span>
                    <label>Expiry Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date when the certificate becomes invalid`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {certificateData.expiry_date && String(certificateData.expiry_date).trim() !== ""
                      ? formatDateToDDMMYYYY(certificateData.expiry_date)
                      : "No Expiry Date"}
                  </span>
                </div>}
               {!showMhCertificateDetailsView && <div className="detail-item">
                  <span>
                    <label>Delivery Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date the certificate is sent to the Channel Partner`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {formatDateToDDMMYYYY(certificateData.delivery_date)}
                  </span>
                </div>}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 24,
                }}
              >
                {showMhCertificateDetailsView && <div className="detail-item">
                  <span>
                    <label>Expiry Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date when the certificate becomes invalid`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {certificateData.expiry_date && String(certificateData.expiry_date).trim() !== ""
                      ? formatDateToDDMMYYYY(certificateData.expiry_date)
                      : "No Expiry Date"}
                  </span>
                </div>}
                <div className="detail-item">
                  <label>Certificate No</label>
                  <span>{certificateData.certificate_number}</span>
                </div>
                <div className="detail-item">
                  <label>Issued By</label>

                  <span>{requestData.assigned_to}</span>
                </div>
                <div className="detail-item">
                  {requestData.distributors && <label>Distributor Mapping</label>}
                  <span>{requestData.distributors}</span>
                </div>
                <div className="detail-item">
                  <label></label>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        )}

        {requestData.status.toLowerCase() == "rejected" && (
          <div className="submitted-details-section">
            <span className="heading">Reason For Rejection</span>
            <div className="details-grid">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <div className="detail-item">
                  <label>Reason Visible to partner</label>
                  <span>{requestData.reason}</span>
                </div>
                <div className="detail-item">
                  <label>Internal Remarks</label>
                  <span>{requestData.remarks}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {!isViewer && !isReadOnly && <div className="action-buttons-container">
          {requestData.status.toLowerCase() ===
            RequestState.APPROVED.toLowerCase() &&
            can(FEATURES.ACTION_DELIVER_CERTIFICATE) && (
              <span className="infoText">
                Deliver Certificate By : {requestData.due_date}
              </span>
            )}
          {isApproveRejectState &&
            canApproveOrReject && (
              <span className="infoText">
                Approve Or Reject By :{" "}
                {formatDateToDDMMYYYY(requestData.due_date)}
              </span>
            )}
          {isApproveRejectState &&
            canApproveOrReject && (
              <span>
                <button className="reject-button" onClick={handleRejectClick}>
                  Reject
                </button>
                <button className="approve-button" onClick={handleApproveClick}>
                  Approve
                </button>
              </span>
            )}
          {(requestData.status.toLowerCase() ===
            RequestState.PENDING_DELIVERY.toLowerCase() ||
            requestData.status.toLowerCase() ===
            RequestState.CERTIFICATE_ISSUANCE.toLowerCase()) &&
            can(FEATURES.ACTION_DELIVER_CERTIFICATE) && <span></span>}


          {(requestData.status.toLowerCase() ===
            RequestState.PENDING_DELIVERY.toLowerCase() ||requestData.status.toLowerCase() ===
            RequestState.CERTIFICATE_ISSUANCE.toLowerCase()
          ) &&
            can(FEATURES.ACTION_DELIVER_CERTIFICATE) && (
              requestData?.unit === 'IN57' && certificateData?.certificate_number ? (
                <span className="infoText">
                  Certificate will be delivered via third-party. Awaiting retailer confirmation.
                </span>
              ) : (
                <span>
                  <button className="delivery-button approve-button" onClick={handleDeliveryClick}>
                    Deliver Certificate
                  </button>
                </span>
              )
            )}



          {/* {requestData.status.toLowerCase() ===
            RequestState.PENDING_DELIVERY.toLowerCase() &&
            userData.role === ROLES.ISSUER && (
              <button
                className="delivery-button"
                onClick={handleDeliveryCodeClick}
              >
                Enter Delivery Code
              </button>
            )} */}

          {requestData.status.toLowerCase() === "active" && (
            <button
              className="cancel-button"
              onClick={() => setShowCancelModal(true)}
              style={{ background: "#c93131", color: "#fff" }}
            >
              Cancel Certificate
            </button>
          )}
        </div>}
      </div>

      {showPreviewModal && (
        <div className="preview-modal-overlay" onClick={handlePreviewClose}>
          <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
            <div className="preview-modal-header">
              <span>File Preview</span>
              <div className="preview-controls">
                <button type="button" onClick={handleZoomOut}>-</button>
                <span>{Math.round(previewZoom * 100)}%</span>
                <button type="button" onClick={handleZoomIn}>+</button>
                <button type="button" onClick={() => setPreviewZoom(1)}>Reset</button>
                <button type="button" onClick={handlePreviewClose}>Close</button>
              </div>
            </div>
            <div className="preview-modal-body">
              <div
                className="preview-file-wrapper"
                style={{ transform: `scale(${previewZoom})`, transformOrigin: "top center" }}
              >
                {previewType === "pdf" ? (
                  <embed src={previewUrl} type="application/pdf" className="preview-file" />
                ) : (
                  <img src={previewUrl} alt="Uploaded file preview" className="preview-file" />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <DistributorMappingModal
        show={showDistributorMappingModal}
        onClose={() => setShowDistributorMappingModal(false)}
        onSubmit={handleDistributorMappingSubmit}
        preselectedDistributorIds={requestData?.distributor_ids || []}
        partnerType={requestData?.partner_type}
        unitCode={requestData?.unit}
      />

      <CancelModal
        show={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onSubmit={handleCancelSubmit}
      />
      {showApproveModal && (
        <ApproveModal
          show={showApproveModal}
          onClose={() => setShowApproveModal(false)}
          onSubmit={handleDeliveryinfoClick}
          onDeliveryCodeSubmit={handleDeliveryCodeSubmit}
          isMH={
            requestData.govt_application_number
              ? requestData.govt_application_number
              : requestData?.certificate?.certificate_number
                ? requestData.certificate.certificate_number
                : ""
          }
          show_govt_approval_tabFlow={isMhLicenseManager}
          bookletData={bookletData}
          partnerData={{ partnerId: requestData.partner_id, requestId: id }}
          initialStep={certificateData?.certificate_number ? 2 : 1}
          unitCode={requestData?.unit}
        />
      )}

      <RejectModal
        show={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        onSubmit={handleRejectSubmit}
        show_govt_approval_tabFlow={isMhLicenseManager}
      />


      <DeliveryCodeModal
        show={showDeliveryCodeModal}
        onClose={() => setShowDeliveryCodeModal(false)}
        onSubmit={handleDeliveryCodeSubmit}
      />
    </div>
  );
};

export default ReviewRequestPage;
